import { render, staticRenderFns } from "./TbExtensaoEdit.vue?vue&type=template&id=76a70a8c&"
import script from "./TbExtensaoEdit.vue?vue&type=script&lang=js&"
export * from "./TbExtensaoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports